// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList
}                         from '../../../components';
import styles                 from './style';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import moment from 'moment';
import { Spinner } from 'react-activity';
import VenueInfo from '../VenueInfo';
import FixtureInfo from '../FixtureInfo';
import ExpenseInfo from '../ExpenseInfo';
import ReportsInfo from '../ReportsInfo';
const is_mobile = device.mobile();

class VenueDetails extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      venue: props.match.params.id,
      info_tab : true,
      fixture_tab: false,
      expense_tab: false,
      marketing_tab: false,
      reports_tab: false,
      data:[],
      loading: true
    };
    this.handleTab = this.handleTab.bind(this);

  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
    this.getVenueDetails();
    // fetchEarningGraphDataIfNeeded();
    // fetchStatsCardDataIfNeeded();
    // fetchStatsTableDataIfNeeded();
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  getVenueDetails(){
    console.log('getVenueDetails')
    console.log('venue_id',this.state.venue)
    const url = `${getLocationOrigin()}/get_venue_list/get_venue_details_for_cm/?venue=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
     .then(checkStatus)
     .then(parseJSON)
     .then(data => {
       if(data.success){
         this.setState({data:data.result,loading:false});
       }
       else{
        alert(data.message)
        window.location.href = `./#/venueLanding`
       }
     }).catch(error => error);
    }

  handleTab(event){
    const name = event.target.name
    if(name == 'venue_info'){
      this.setState({info_tab:true,fixture_tab:false,expense_tab:false,marketing_tab:false,reports_tab:false})
    }
    else if(name == 'fixture'){
      this.setState({fixture_tab:true,info_tab:false,expense_tab:false,marketing_tab:false,reports_tab:false})
    }
    else if(name == 'expense'){
      this.setState({expense_tab:true,info_tab:false,fixture_tab:false,marketing_tab:false,reports_tab:false})
    }
    else if(name == 'marketing'){
      this.setState({marketing_tab:true,info_tab:false,fixture_tab:false,expense_tab:false,reports_tab:false})
    }
    else if(name == 'reports'){
      this.setState({reports_tab:true,info_tab:false,fixture_tab:false,marketing_tab:false,expense_tab:false})
    }
  }

  render() {
    const venue = {'venue':this.state.venue}
    var booking_check=['8720']
    if(this.state.data.is_court_booking_allowed){
      booking_check[0]='6251'
    }
    return(
      <div style={styles.container}>
        {this.state.loading === true ?
          <div style={{height:500}}>
            <div style={{  position: 'absolute',top: '50%',left: '50%',width: '50%',height: '100%'}}> <Spinner size="50" /></div>
          </div>
          :
          <div style={styles.page}>
            <div style={styles.header}>
              <button type="button" style={styles.backBtn} onClick={() => history.back()} title="Back">
                <i className="fa fa-arrow-left" aria-hidden="true"></i>
              </button>
              <div style={styles.headerText}>
                <div style={styles.headerTitleRow}>
                  <h2 style={styles.venueName}>{this.state.data.name}</h2>
                  <span style={this.state.data.status == 'Open' ? styles.statusActive : styles.statusInactive}>
                    {this.state.data.status == 'Open' ? "Active" : 'Inactive'}
                  </span>
                </div>
                <div style={styles.headerSub}>
                  {[this.state.data.location && this.state.data.location.hood, this.state.data.city].filter(Boolean).join(', ')}
                </div>
              </div>
              {
                (localStorage.getItem('access') == 'Trespasser' || localStorage.getItem('access') == 'Partner' || localStorage.getItem('access') == 'Delivery Manager' || localStorage.getItem('access') == 'Lead Buddy') &&
                  <div style={styles.actions}>
                    <Link to={`../crud/editVenue/${this.state.venue}`}>
                      <button className='btn btn-primary' style={styles.btn1}>
                        <i className="fa fa-pencil " aria-hidden="true" style={{paddingRight:'5px'}}></i>
                        Edit Venue
                      </button>
                    </Link>
                    <Link to={`../crud/editCourtPricing/${this.state.venue}/${booking_check[0]}`}>
                      <button className='btn btn-primary' style={styles.btn1}>Packages</button>
                    </Link>
                    {this.state.data.is_court_booking_allowed &&
                      <Link to={`../crud/courtList/${this.state.venue}`}>
                        <button className='btn btn-primary' style={styles.btn1}>Courts</button>
                      </Link>
                    }
                  </div>
              }
            </div>

            <div style={styles.card}>
              <h3 style={styles.cardTitle}>Venue Details</h3>
              <div style={styles.detailGrid}>
                <div style={styles.detailItem}>
                  <div style={styles.label}>City</div>
                  <div style={styles.value}>{this.state.data.city || '—'}</div>
                </div>
                <div style={styles.detailItem}>
                  <div style={styles.label}>Location</div>
                  <div style={styles.value}>{this.state.data.location ? this.state.data.location.hood : '—'}</div>
                </div>
                <div style={{...styles.detailItem, ...styles.detailWide}}>
                  <div style={styles.label}>Address</div>
                  <div style={styles.value}>{this.state.data.full_address || '—'}</div>
                </div>
                <div style={styles.detailItem}>
                  <div style={styles.label}>Working Hours</div>
                  <div style={styles.value}>
                    {moment(this.state.data.start_time, 'HH:mm:ss').format('hh:mm A')}&nbsp;-&nbsp;
                    {moment(this.state.data.end_time, 'HH:mm:ss').format('hh:mm A')}
                  </div>
                </div>
                <div style={styles.detailItem}>
                  <div style={styles.label}>Games</div>
                  <div style={styles.value}>{this.state.data.games.map(g => g.game_name).join(', ') || '—'}</div>
                </div>
                <div style={styles.detailItem}>
                  <div style={styles.label}>Court Booking Enabled</div>
                  <div style={styles.value}>{this.state.data.is_court_booking_allowed ? "Yes" : "No"}</div>
                </div>
                <div style={styles.detailItem}>
                  <div style={styles.label}>Contact</div>
                  <div style={styles.value}>{this.state.data.contact_no || '—'}</div>
                </div>
                <div style={styles.detailItem}>
                  <div style={styles.label}>Primary Center Manager</div>
                  <div style={styles.value}>
                    {this.state.data.primary_center_manager && this.state.data.primary_center_manager.name ?
                      <span>
                        {this.state.data.primary_center_manager.name}
                        {this.state.data.primary_center_manager.number &&
                          <span style={styles.partnerNumber}>({this.state.data.primary_center_manager.number})</span>}
                      </span>
                      : '—'}
                  </div>
                </div>
                <div style={styles.detailItem}>
                  <div style={styles.label}>Relationship Manager</div>
                  <div style={styles.value}>
                    {this.state.data.relationship_manager && this.state.data.relationship_manager.name ?
                      <span>
                        {this.state.data.relationship_manager.name}
                        {this.state.data.relationship_manager.number &&
                          <span style={styles.partnerNumber}>({this.state.data.relationship_manager.number})</span>}
                      </span>
                      : '—'}
                  </div>
                </div>
                <div style={{...styles.detailItem, ...styles.detailWide}}>
                  <div style={styles.label}>Partner</div>
                  <div style={styles.value}>
                    {this.state.data.partners.length > 0 ?
                      this.state.data.partners.map((each, index) => (
                        <div key={index} style={styles.partnerItem}>
                          <span>{each.name}</span>
                          <span style={styles.partnerNumber}>({each.number})</span>
                        </div>
                      ))
                      : '—'}
                  </div>
                </div>
              </div>
            </div>

            <div className='col-md-12' style={{padding:'0'}}>
            { 
              this.state.info_tab &&
              <VenueInfo venue={this.state.venue}/>
              }
            {
              this.state.fixture_tab &&
              <FixtureInfo venue={this.state.venue}/>
            }
            {
              this.state.expense_tab &&
              <ExpenseInfo venue={this.state.venue}/>
            }
            {
              this.state.marketing_tab &&
              <div> Not Implemented Yet </div>
            }
            {
              this.state.reports_tab &&
              <ReportsInfo venue={this.state.venue}/>
            }

            </div>
          </div>
        }
      </div>
    );
  }
}

export default VenueDetails;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/venueDetails/VenueDetails.js